import { MediaAssetProviders } from '@/features/ai-video-creator/stores/productMediaSlice';
import { Avatar, AvatarType } from '@/types/avatar';
import { ICardMediaAsset } from '@/types/media';
import { PersonalAvatarViewData } from '@/api/personal-avatars';
import useRouterNavigation from '@/hooks/useRouterNavigation';
import StudioRoutes from '@/utils/routes';
import { useCallback } from 'react';

export const useMediaInStudioVideo = ({ media }: { media: ICardMediaAsset | Avatar | PersonalAvatarViewData }) => {
  const { pushPath } = useRouterNavigation();

  const handleUseInStudioVideo = useCallback(() => {
    switch (media.type) {
      case AvatarType.Personal:
        pushPath(
          StudioRoutes.createProject({
            avatar: media.id,
          })
        );
        break;
      case AvatarType.Default:
      case AvatarType.BunuPersonal:
        pushPath(
          StudioRoutes.createProject({
            defaultAvatar: media.id,
          })
        );
        break;
      default:
        const asset = media as ICardMediaAsset;
        pushPath(
          StudioRoutes.createProject({
            assetId: asset.id,
            assetSrc: asset.src || '',
            assetType: asset.type,
            assetProvider: asset.source as MediaAssetProviders,
          })
        );
        break;
    }
  }, [media, pushPath]);
  return { handleUseInStudioVideo };
};
